import { h } from 'preact';
import preact from 'preact';
import cached from 'utils/cached';
// import { getMapTiler } from 'utils/bolt/gmaps';

import s from 'components/bolt/showtimes/mapMarker.sss';

const createMapPin = () => {
	const xmlns = 'http://www.w3.org/2000/svg';
	const svgElem = document.createElementNS(xmlns, 'svg');
	const path = document.createElementNS(xmlns, 'path');

	svgElem.setAttributeNS(null, 'viewBox', '0 0 16 16');
	path.setAttributeNS(null, 'd', 'M8 1a6.09 6.09 0 0 0-4.243 1.697 5.654 5.654 0 0 0 0 8.193l.014.012v.015L8 15l4.191-4.047v-.015l.051-.048a5.652 5.652 0 0 0 0-8.193A6.087 6.087 0 0 0 8 1');
	svgElem.appendChild(path);

	return svgElem;
};

export const createClass = cached(async () => {

	class Marker {
		constructor(options) {
			let { position, activeLogoLink, inactiveLogoLink, onClick, isActive, anchor, noPin, extraComp } = options;

			this.isActive = isActive;
			this.activeLogoLink = activeLogoLink;
			this.inactiveLogoLink = inactiveLogoLink;

			this.pin = createMapPin();

			this.position = position;
			this.container = document.createElement('div');
			this.container.classList.add(s.marker);

			if (options.class) {
				this.container.classList.add(options.class);
			}

			if (isActive) {
				this.container.classList.add(s.active);
			}

			if (!noPin) {
				this.pin = createMapPin();
				this.container.appendChild(this.pin);
			}

			if (extraComp) {
				const extraEle = preact.render(h(extraComp));
				this.container.appendChild(extraEle);
			}

			this.logo = document.createElement('img');
			this.logo.src = isActive ? activeLogoLink : inactiveLogoLink;
			this.container.appendChild(this.logo);

			this.container.onclick = () => onClick(this);

			this.marker = new window.mapboxgl.Marker({
				element: this.container,
				anchor: anchor || 'bottom'
			}).setLngLat(position);
		}

		setMap(map) {
			if (map) {
				this.marker.addTo(map);
			} else {
				this.marker.remove();
			}
		}

		makeInactive() {
			this.container.classList.remove(s.active);
			this.logo.src = this.inactiveLogoLink;
			this.isActive = false;
		}

		makeActive() {
			this.container.classList.add(s.active);
			this.logo.src = this.activeLogoLink;
			this.isActive = true;
		}
	}

	return Marker;
});

export const createMapTilerMarker = async (options, map) => {
	let Marker = await createClass();
	let marker = new Marker(options, map);
	if (map) {
		marker.setMap(map);
	}
	return marker;
};
